module.exports = __webpack_public_path__ + "static/img/MOTRNew.952f629.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MOTRNew.jpg
// module id = q7Nh
// module chunks = 1